import { apiClient } from '@/utils/api-client'

/**
 * Usage service for retrieving flag usage data.
 */
class UsageService {
    /**
     * Get usage history series for charting.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @param {string} flagKey - Flag key
     * @param {string} period - Time period (24h, 7d, 30d, 90d)
     * @param {boolean} compare - Whether to include previous-period comparison
     * @returns {Promise<Object>} Usage history response
     */
    async history(projectKey, environmentKey, flagKey, period, compare) {
        return await apiClient
            .get(
                '/projects/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/flags/' +
                    flagKey +
                    '/usage?period=' +
                    period +
                    '&compare=' +
                    compare
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * Get the last usage information for a flag.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @param {string} flagKey - Flag key
     * @returns {Promise<Object>} Usage response
     */
    async lastUse(projectKey, environmentKey, flagKey) {
        return await apiClient
            .get(
                '/projects/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/flags/' +
                    flagKey +
                    '/usage/last'
            )
            .then((response) => {
                return response.data
            })
    }
}

export default new UsageService()
